// extracted by mini-css-extract-plugin
export default {"iconLink":"FavoriteButton_iconLink__iZh3f","icon":"FavoriteButton_icon__ZAgLA","iconLinkActive":"FavoriteButton_iconLinkActive__k6sID"};